export default "__VITE_ASSET__Ci$6Y2yg__"